/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    availableFrom: z.coerce.date(),
    leaseTermMonths: z.number().gte(3, { message: "Lease term must be at least 3 months." }).lte(60, { message: "Lease term must be no more than 5 years." }),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    availableFrom: z.coerce.date(),
    leaseTermMonths: z.number().gte(3, { message: "Lease term must be at least 3 months." }).lte(60, { message: "Lease term must be no more than 5 years." }),
}
).strict();
const relationSchema = z.object({
    listing: z.record(z.string(), z.unknown()),
    tenantScreeningCriteria: z.record(z.string(), z.unknown()).optional(),
}
);
const fkSchema = z.object({
    listingId: z.string(),
}
);

/**
* Schema refinement function for applying `@@validate` rules.
*/
export function refineForLease<T, D extends z.ZodTypeDef>(schema: z.ZodType<T, D, T>) {
    return schema.refine((value: any) => ((value?.availableFrom) !== undefined ? ((value?.availableFrom > (new Date()))) : true), { message: "Available from date must be in the future.", path: ['availableFrom'], });
}


/**
 * `ForLease` schema excluding foreign keys and relations.
 */
export const ForLeaseScalarSchema = baseSchema;


/**
 * `ForLease` schema prior to calling `.refine()` for extensibility.
 */
export const ForLeaseWithoutRefineSchema = ForLeaseScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * `ForLease` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const ForLeaseSchema = refineForLease(ForLeaseWithoutRefineSchema);


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const ForLeasePrismaCreateSchema = refineForLease(baseSchemaWithoutDefaults.partial().passthrough());


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const ForLeasePrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    availableFrom: z.coerce.date(),
    leaseTermMonths: z.union([z.number().gte(3, { message: "Lease term must be at least 3 months." }).lte(60, { message: "Lease term must be no more than 5 years." }), z.record(z.string(), z.unknown())])
}).partial().passthrough();


/**
 * `ForLease` schema for create operations excluding foreign keys and relations.
 */
export const ForLeaseCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true
});


/**
 * `ForLease` schema for create operations prior to calling `.refine()` for extensibility.
 */
export const ForLeaseCreateWithoutRefineSchema = ForLeaseCreateScalarSchema.merge(fkSchema);


/**
 * `ForLease` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const ForLeaseCreateSchema = refineForLease(ForLeaseCreateWithoutRefineSchema);


/**
 * `ForLease` schema for update operations excluding foreign keys and relations.
 */
export const ForLeaseUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `ForLease` schema for update operations prior to calling `.refine()` for extensibility.
 */
export const ForLeaseUpdateWithoutRefineSchema = ForLeaseUpdateScalarSchema.merge(fkSchema.partial());


/**
 * `ForLease` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const ForLeaseUpdateSchema = refineForLease(ForLeaseUpdateWithoutRefineSchema);

